import { ReactElement } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { CancelOutlined, Minimize } from "@mui/icons-material";
import { LastExecution } from "@/services/cloudchipr.api";

export const lastExecutionStateIcon = new Map<
  LastExecution["status"],
  ReactElement
>([
  [
    "succeeded",
    <CheckCircleOutlineIcon color="success" fontSize="small" key="succeed" />,
  ],
  ["failed", <CancelOutlined color="error" fontSize="small" key="failed" />],
  [
    "skipped",
    <Minimize color="action" fontSize="small" key="skipped" sx={{ mb: 1.5 }} />,
  ],
]);

export const lastExecutionChipColor = new Map<
  LastExecution["status"],
  "success" | "error" | "default"
>([
  ["succeeded", "success"],
  ["failed", "error"],
  ["skipped", "default"],
]);
